import { API_BASE_URL } from '../../config'
import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  CLEAR_REGISTER_ERROR
} from './registerActionTypes'
import { LOGIN_SUCCESS } from '../Auth/authActionTypes'

export const registerUser = (userData) => async (dispatch) => {
  dispatch({ type: REGISTER_REQUEST })

  try {
    const response = await fetch(`${API_BASE_URL}/auth/registration/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(userData)
    })

    const data = await response.json()

    if (!response.ok) {
      throw new Error(data.detail || 'Registration failed')
    }

    dispatch({
      type: REGISTER_SUCCESS,
      payload: data
    })

    // Store the access token and authenticate the user
    if (data.key) {
      localStorage.setItem('auth_token', data.key)
      // Dispatch login success to update auth state
      dispatch({
        type: LOGIN_SUCCESS,
        payload: { key: data.key }
      })
    }

    return data
  } catch (error) {
    dispatch({
      type: REGISTER_FAILURE,
      payload: error.message || 'Registration failed. Please try again.'
    })
    throw error
  }
}

export const clearRegisterError = () => ({
  type: CLEAR_REGISTER_ERROR
})
